import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import "font-awesome/css/font-awesome.css";
import VueHtml2Canvas from "vue-html2canvas";
import moment from "moment";
import VBodyScrollLock from "v-body-scroll-lock";
Vue.use(VueHtml2Canvas);
Vue.prototype.moment = moment;
Vue.config.productionTip = false;
Vue.use(VBodyScrollLock);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
